import { Field, NumericInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { PassingIntermediateSieveRequirement } from 'Components/Worksheets/LosAngelesValueWorksheet/types';
import { useSelector } from 'react-redux';

let BsEnPreparationTestPortionMassSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  var passingIntermediateSieveRequirement = [
    { label: '30 to 40', value: PassingIntermediateSieveRequirement.Pass30To40Percentage },
    { label: '45 to 55', value: PassingIntermediateSieveRequirement.Pass45To55Percentage },
    { label: '50', value: PassingIntermediateSieveRequirement.Pass50Percentage },
    { label: '60 to 70', value: PassingIntermediateSieveRequirement.Pass60To70Percentage },
  ];

  const requiredPassingMassIntermediateSieve = useSelector(
    createWorksheetSelector!('RequiredPassingMassIntermediateSieve')
  );

  return (
    <SectionGroup heading="Test Portion Mass">
      <ListFieldSection>
        <Field input={<TextOutput />} name="RecommendedCoarsePortionMass" />
        <Field input={<NumericInput />} name="CoarsePortionMass" />
        <Field input={<TextOutput />} name="RecommendedFinePortionMass" />
        <Field input={<NumericInput />} name="FinePortionMass" />
        <Field input={<TextOutput />} name="TotalPortionMass" />
        <Field
          input={<TextOutput />}
          name="RequiredPassingMassIntermediateSieve"
          value={
            passingIntermediateSieveRequirement.find((x) => x.value === requiredPassingMassIntermediateSieve)?.label
          }
        />
        <Field input={<TextOutput />} name="PassingMassIntermediateSieve" />
      </ListFieldSection>
    </SectionGroup>
  );
};

BsEnPreparationTestPortionMassSection = withInjectedProps(BsEnPreparationTestPortionMassSection);

export { BsEnPreparationTestPortionMassSection };
export default BsEnPreparationTestPortionMassSection;
